import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "廉価" },
  { value: 2, text: "Amazon" },
  { value: 3, text: "大綱" },
  { value: 4, text: "ソフマップ" },
  { value: 5, text: "注力法人" },
]);
